/**
 * Heatmap color coding constants
 *
 * Shared between ProfilerHeatmap (assigns colors to companies)
 * and HeatmapLegend (displays the legend).
 *
 * Color assignment logic (ProfilerHeatmap.jsx):
 * - value > HIGH_THRESHOLD: green zone
 *   - Top 25% → BEST (dark green)
 *   - Rest → BEST_REST (light green)
 * - LOW_THRESHOLD to HIGH_THRESHOLD: NEUTRAL (grey)
 * - value < LOW_THRESHOLD: red zone
 *   - Bottom 25% → WORST (dark red)
 *   - Rest → WORST_REST (light red)
 */
export const HEATMAP_COLORS = {
  BEST: '#056636',
  BEST_REST: '#089950',
  NEUTRAL: '#c9c9c9',
  WORST_REST: '#f23645',
  WORST: '#991f29'
};

export const HEATMAP_THRESHOLDS = {
  LOW: 0,
  HIGH: 2
};
